var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedNumber } from 'react-intl';
import { getResourceName } from '@/shared/components/ResourceName';
import DashboardTile from './DashboardTile';
import messages from '../../dashboardMessages';
var DashboardAbsenceTile = function (_a) {
    var _b, _c, _d;
    var data = _a.data, className = _a.className, intl = _a.intl, inDays = _a.inDays;
    var title = getResourceName(intl, data.resource);
    var value = data.startValueDays !== null ? (_jsxs("span", __assign({ title: intl.formatMessage(messages.CounterBalanceStartValue, {
            balanceDays: data.balanceDays,
            balanceHours: data.balance,
            startValueHours: data.startValue,
            startValueDays: data.startValueDays,
        }) }, { children: [_jsx(FormattedNumber, { value: (_b = (inDays ? data.balanceDays : data.balance)) !== null && _b !== void 0 ? _b : 0, maximumFractionDigits: 2 }), "\u00A0/\u00A0", _jsx(FormattedNumber, { value: (_c = (inDays ? data.startValueDays : data.startValue)) !== null && _c !== void 0 ? _c : 0, maximumFractionDigits: 2 })] }))) : (_jsx("span", __assign({ title: intl.formatMessage(messages.AbsenceWidgetWithoutCounterTooltip, {
            balanceDays: data.balanceDays,
            balanceHours: data.balance,
        }) }, { children: _jsx(FormattedNumber, { value: (_d = (inDays ? data.balanceDays : data.balance)) !== null && _d !== void 0 ? _d : 0, maximumFractionDigits: 2 }) })));
    return _jsx(DashboardTile, { title: title, value: value || 0, titleClassName: className });
};
export default DashboardAbsenceTile;
